import { ReactComponent as CommentsDollarIcon } from '../../../assets/images/common/icons/comments-dollar-duotone.svg'
import { ReactComponent as CloneIcon } from '../../../assets/images/common/icons/clone-regular.svg'
import { ReactComponent as MailIcon } from '../../../assets/images/common/icons/mail-icon.svg'
import styles from './CoachDashboardProgramsOverview.module.scss'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const ProgramsOverviewAction = ({ programs, spots, enrollments }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <div className={styles.programsOverviewAction}>
      <div className={styles.textContainer}>
        <CommentsDollarIcon className={styles.actionIcon}/>
        <div className={styles.actionText}>
          {programs === 0 &&
            <p>
              {t('dashboard.coach.programsOverviewAction.noProgramsMessage')}
            </p>
          }
          {programs > 0 && enrollments === 0 &&
            <>
              <p>
                {spots
                  ? t('dashboard.coach.programsOverviewAction.programsLiveWithSpots', { programs, spots })
                  : t('dashboard.coach.programsOverviewAction.programsLive', { programs })}
              </p>
              <p>
                {t('dashboard.coach.programsOverviewAction.revenueOpportunity')}
              </p>
            </>
          }
          {programs > 0 && enrollments > 0 &&
            <>
              <p>{t('dashboard.coach.programsOverviewAction.congratulations')}</p>
              <p>{t('dashboard.coach.programsOverviewAction.programsAndEnrollments', { programs, enrollments })}</p>
              <p>
                {t('dashboard.coach.programsOverviewAction.startCommunicating')}
              </p>
              <p>{t('dashboard.coach.programsOverviewAction.manageEnrollments')}</p>
            </>
          }

        </div>
      </div>

      <div className={styles.buttonContainer}>
        {programs === 0 &&
          <button
            className='btn btn-primary text-white'
            onClick={() => navigate('/programs/new')}
          >
            {t('dashboard.coach.programsOverviewAction.buildProgramButton')}
          </button>
        }
        {programs > 0 && enrollments === 0 &&
          <>
            <button
              onClick={() => navigator.clipboard.writeText(`${process.env.REACT_APP_BASE_URL}/landing/${1}/`)}
              className={styles.actionButton}
            >
              <CloneIcon className={styles.buttonIcon} />
              {t('dashboard.coach.programsOverviewAction.copyLandingPageLinkButton')}
            </button>
            <button
              className='btn btn-primary text-white'
              onClick={() => navigate('/resource-sections')}
            >
              {t('dashboard.coach.programsOverviewAction.viewResourcesButton')}
            </button>
          </>
        }

        {programs > 0 && enrollments > 0 &&
          <>
            <button
              onClick={() => navigate('/announcements')}
              className={styles.actionButton}
            >
              <MailIcon className={styles.buttonIcon} />
              {t('dashboard.coach.programsOverviewAction.sendEmailButton')}
            </button>
            <button
              className='btn btn-primary text-white'
              onClick={() => navigate('/programs')}
            >
              {t('dashboard.coach.programsOverviewAction.manageProgramsButton')}
            </button>
          </>
        }
      </div>
    </div>
  )
}

ProgramsOverviewAction.propTypes = {
  programs: PropTypes.number,
  spots: PropTypes.number,
  enrollments: PropTypes.number,
}

export default ProgramsOverviewAction
